
export const domain = `livestream.ua`;
export const protocol = 'https://';
export const watchKeyParam = 'nxg72hDMjuQrVb78O33Htj9chswzc15q';
 
export const AppConfig = {
//wss://${domain}
    webSocketIncomeControlUrl: `/income_control`, 
    webSocketUsersControlUrl: `/user_control`, 
    webSocketStreamsControlUrl: `/streams_control`,
    webSocketStreamsWatchUrl: `/streams_watch`,
    webSocketStreamsOverviewUrl: `/streams_overview`, 
    webSocketCdnControlUrl: `/cnd_control`,
    webSocketChatUrl: `/chat_controller`,
    webSocketRestreamsOverviewUrl: `/restreams_overview`, 
    webSocketQrEnterWatchUrl: `/qr_enter`, 
    webSocketVideosControlUrl: `/video_control`, 
    webSocketVideosOverviewUrl: `/video_overview_control`, 
    webSocketAdminDashboardUrl: `/admin_dashboard_control`, 
    webSocketAdminUsersOnlineUrl: `/admin_users_online_control`, 
    webSocketAdminLogUrl: `/admin_log_control`,
 //

}

 
